import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AmenityService } from '../../../services/amenity.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SpinnerService } from '../../../services/spinner.service';
import { Amenity } from '../../../models/amenity.model';
import { AmenityModalComponent } from '../../../components/amenity-modal/amenity-modal.component';
import { TimetableModalComponent } from '../../../components/timetable-modal/timetable-modal.component';
import { CreateBookingModalComponent } from '../../../components/create-booking-modal/create-booking-modal.component';

@Component({
  selector: 'app-amenities-page',
  templateUrl: './amenities-page.component.html',
  styleUrl: './amenities-page.component.scss'
})
export class AmenitiesPageComponent {

  public neighborhoodId?: string;

  constructor(
    private activatedRoute: ActivatedRoute,
    public amenityService: AmenityService,
    private modalService: NgbModal,
    public spinnerService: SpinnerService
  ) {
    this.activatedRoute.params.subscribe(
      async params => {
        this.neighborhoodId = params['neighborhoodId'];
        await this.amenityService.getAll(this.neighborhoodId!);
      }
    );
  }

  /*
   ██████╗██████╗ ███████╗ █████╗ ████████╗███████╗██████╗  ██████╗  ██████╗ ██╗  ██╗██╗███╗   ██╗ ██████╗
  ██╔════╝██╔══██╗██╔════╝██╔══██╗╚══██╔══╝██╔════╝██╔══██╗██╔═══██╗██╔═══██╗██║ ██╔╝██║████╗  ██║██╔════╝
  ██║     ██████╔╝█████╗  ███████║   ██║   █████╗  ██████╔╝██║   ██║██║   ██║█████╔╝ ██║██╔██╗ ██║██║  ███╗
  ██║     ██╔══██╗██╔══╝  ██╔══██║   ██║   ██╔══╝  ██╔══██╗██║   ██║██║   ██║██╔═██╗ ██║██║╚██╗██║██║   ██║
  ╚██████╗██║  ██║███████╗██║  ██║   ██║   ███████╗██████╔╝╚██████╔╝╚██████╔╝██║  ██╗██║██║ ╚████║╚██████╔╝
   ╚═════╝╚═╝  ╚═╝╚══════╝╚═╝  ╚═╝   ╚═╝   ╚══════╝╚═════╝  ╚═════╝  ╚═════╝ ╚═╝  ╚═╝╚═╝╚═╝  ╚═══╝ ╚═════╝

  */
  async createBooking(
    amenity: Amenity
  ) {

    const modalRef = this.modalService.open(
      CreateBookingModalComponent,
    );

    modalRef.componentInstance.neighborhoodId = this.neighborhoodId;
    modalRef.componentInstance.amenity = amenity;

  }

  async delete(
    amenity: Amenity
  ) {
    const flag = confirm(`¿Está seguro que desea borrar la amenidad "${amenity.name}"?`);

    if (flag) {
      await this.amenityService.delete(amenity);
    }
  }

  open(
    amenity?: Amenity
  ) {
    const modalRef = this.modalService.open(
      AmenityModalComponent
    );

    modalRef.componentInstance.neighborhoodId = this.neighborhoodId;
    modalRef.componentInstance.amenity = amenity;
  }

  /*
   ██████╗ ██████╗ ███████╗███╗   ██╗████████╗██╗███╗   ███╗███████╗████████╗ █████╗ ██████╗ ██╗     ███████╗
  ██╔═══██╗██╔══██╗██╔════╝████╗  ██║╚══██╔══╝██║████╗ ████║██╔════╝╚══██╔══╝██╔══██╗██╔══██╗██║     ██╔════╝
  ██║   ██║██████╔╝█████╗  ██╔██╗ ██║   ██║   ██║██╔████╔██║█████╗     ██║   ███████║██████╔╝██║     █████╗
  ██║   ██║██╔═══╝ ██╔══╝  ██║╚██╗██║   ██║   ██║██║╚██╔╝██║██╔══╝     ██║   ██╔══██║██╔══██╗██║     ██╔══╝
  ╚██████╔╝██║     ███████╗██║ ╚████║   ██║   ██║██║ ╚═╝ ██║███████╗   ██║   ██║  ██║██████╔╝███████╗███████╗
   ╚═════╝ ╚═╝     ╚══════╝╚═╝  ╚═══╝   ╚═╝   ╚═╝╚═╝     ╚═╝╚══════╝   ╚═╝   ╚═╝  ╚═╝╚═════╝ ╚══════╝╚══════╝

  */
  openTimetable(
    amenity: Amenity
  ) {
    const modalRef = this.modalService.open(
      TimetableModalComponent,
      {
        size: 'xl',
      }
    );

    modalRef.componentInstance.neighborhoodId = this.neighborhoodId;
    modalRef.componentInstance.amenity = amenity;
  }

  /*
    ██╗   ██╗██████╗ ██████╗  █████╗ ████████╗███████╗
    ██║   ██║██╔══██╗██╔══██╗██╔══██╗╚══██╔══╝██╔════╝
    ██║   ██║██████╔╝██║  ██║███████║   ██║   █████╗
    ██║   ██║██╔═══╝ ██║  ██║██╔══██║   ██║   ██╔══╝
    ╚██████╔╝██║     ██████╔╝██║  ██║   ██║   ███████╗
     ╚═════╝ ╚═╝     ╚═════╝ ╚═╝  ╚═╝   ╚═╝   ╚══════╝
  
    */
    /**
     * FUNCTION update
     * 
     * @param amenity 
     */
    async update(
      amenity: Amenity
    ) {
  
      console.log(amenity);
      
  
      this.spinnerService.loading = true;
      this.spinnerService.message = 'Actualizando amenidad';
  
      await this.amenityService.update(
        amenity
      );
  
    }

}
